import { render, staticRenderFns } from "./OrderGoodsSubmit.vue?vue&type=template&id=47cbcc7c&scoped=true&"
import script from "./OrderGoodsSubmit.vue?vue&type=script&lang=js&"
export * from "./OrderGoodsSubmit.vue?vue&type=script&lang=js&"
import style0 from "./OrderGoodsSubmit.vue?vue&type=style&index=0&id=47cbcc7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cbcc7c",
  null
  
)

export default component.exports